<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="
				_modal__content
				px-12
				py-6
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<img
					alt="Luca Education"
					height="60"
					src="@/assets/images/illustrations/warning.png"
					title="Luca Education"
					width="60"
				/>
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
					text-center
				"
			>
				Bạn cần nâng cấp để sử dụng tính năng này
			</div>
			<div class="text-center text-neutral-500 mt-2">
				Bạn đang sử dụng gói Cộng đồng, không hỗ trợ tải tài liệu.<br />
				Đăng ký gói Trả phí để mở khóa tính năng tải tài liệu và nhiều
				công cụ nâng cao khác của Luca Education.
			</div>
		</div>
		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
			"
		>
			<button
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				type="button"
				@click="$emit('close')"
			>
				Để sau
			</button>
			<a
				target="_blank"
				href="https://docs.google.com/forms/d/1wbi3QVCwCLJV5odp3JE0S14BZUNMpvs8y9NtmTbVGpk/viewform?edit_requested=true"
				class="button-p text-center whitespace-nowrap"
				type="button"
			>
				Nâng cấp ngay
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'UpgradeConfirm',
};
</script>
